const { every, find, get, some } = require('lodash');
const operators = require('./operators')
const unflatten = require('./unflatten');
const ruleToFunction = rule => {
    const { attribute, operator, value } = rule;
    let statePath = `${get(attribute, 'value.pageId')}.${get(attribute, 'value.id')}`;
    if (attribute.value && attribute.value.repeatingSection) {
        statePath = `${get(attribute, 'value.pageId')}.${get(attribute, 'value.sectionId')}.${get(attribute, 'value.repeatingSectionIndex', '0')}.${get(attribute, 'value.id')}`;
    }
    return state => {
        return new Promise(resolve => {
            let result = false;
            const lvalue = get(state, statePath, '');
            const { fn } = find(operators[attribute.type], { value: operator }) || {};
            if (fn) {
                result = fn(lvalue, value);
            }
            resolve(result);
        });
    };
};
const evaluateGroupRules = (group, groupConditions, state) => {
    return new Promise(resolve => {
        const found = groupConditions.find(it => it.id === group.id);
        if (!found) {
            resolve(false);
            return;
        }
        const { condition } = found;
        if (group.rules.length === 0 && group.groups.length === 0) {
            resolve(false);
            return;
        }
        const evaluations = [].concat(group.rules.map(fn => fn(state)), group.groups.map(it => {
            return evaluateGroupRules(it, groupConditions, state);
        }));
        Promise.all(evaluations)
        .then(results => {
            if (condition === 'AND') {
                resolve(every(results));
                return;
            }
            resolve(some(results));
        });
    });
};
const executor = query => {
    if (!query || !query.where) {
        return () => Promise.resolve(true);
    }
    if (!query.groups) {
        return () => Promise.resolve(false);
    }
    const { groups: groupConditions } = query;
    const unflattenedQuery = unflatten(query, ruleToFunction);
    const fn = (state = {}) => {
        return new Promise(resolve => {
            if (unflattenedQuery.groups.length === 0 && unflattenedQuery.rules.length === 0) {
                resolve(true);
                return;
            }
            evaluateGroupRules(unflattenedQuery, groupConditions, state)
            .then(resolve);
        });
    };
    return fn;
};
module.exports = executor;
